import { AddressEnum, FormFieldTypes } from './types/address-form-types.js';

const taxIdInfoMessageKey = 'customer-data.form.taxId.hint';
const formCommonFields = [
    {
        fieldName: AddressEnum.countryShortName,
        fieldType: FormFieldTypes.SELECT,
        colSpan: 12,
    },
    {
        fieldName: AddressEnum.firstName,
        fieldType: FormFieldTypes.TEXT,
        colSpan: 6,
    },
    {
        fieldName: AddressEnum.lastName,
        fieldType: FormFieldTypes.TEXT,
        colSpan: 6,
    },
    {
        fieldName: AddressEnum.street,
        fieldType: FormFieldTypes.TEXT,
        colSpan: 12,
    },
    {
        fieldName: AddressEnum.additionalInformation,
        fieldType: FormFieldTypes.TEXT,
        colSpan: 12,
        hasInfoMessage: true,
    },
    {
        fieldName: AddressEnum.postalCode,
        fieldType: FormFieldTypes.TEXT,
        colSpan: 6,
    },
    {
        fieldName: AddressEnum.city,
        fieldType: FormFieldTypes.TEXT,
        colSpan: 6,
    },
];
const phoneNumberField = {
    fieldName: AddressEnum.phoneNumber,
    fieldType: FormFieldTypes.TELEPHONE,
    colSpan: 12,
    hasInfoMessage: true,
};
const birthDateField = {
    fieldName: AddressEnum.birthDate,
    fieldType: FormFieldTypes.DATE,
    colSpan: 6,
};
const taxIDField = {
    fieldName: AddressEnum.taxId,
    fieldType: FormFieldTypes.TEXT,
    colSpan: 12,
};
const taxIdInfoBox = {
    fieldName: taxIdInfoMessageKey,
    fieldType: FormFieldTypes.INFO_BOX,
    rowNumber: 8,
    startIndex: 1,
    colSpan: 12,
};
const lengthError = 'customer-data.form.size.error';
const errorMessageKeys = {
    required: 'customer-data.form.required.error',
    minLength: lengthError,
    maxLength: lengthError,
};
const specialCharsError = 'customer-data.form.specialchars.error';
const patternErrorKeys = {
    firstName: specialCharsError,
    lastName: specialCharsError,
    phoneNumber: specialCharsError,
    street: 'customer-data.form.street.error',
    postalCode: 'customer-data.form.postcode.error',
    taxId: 'customer-data.form.taxId.error',
};
const TAX_ID_FIELD_POSITION = 3;
const PHONE_FIELD_POSITION = 3;
const ADD_NEW_DELIVERY_ADDRESS_LINK_POSITION = 7;
const addNewDeliveryAddressLink = {
    fieldName: AddressEnum.addNewDeliveryAddress,
    fieldType: FormFieldTypes.ANCHOR,
    colSpan: 12,
    callback: () => { },
};

export { ADD_NEW_DELIVERY_ADDRESS_LINK_POSITION, PHONE_FIELD_POSITION, TAX_ID_FIELD_POSITION, addNewDeliveryAddressLink, birthDateField, errorMessageKeys, formCommonFields, patternErrorKeys, phoneNumberField, taxIDField, taxIdInfoBox, taxIdInfoMessageKey };
//# sourceMappingURL=constants.js.map
